import React, { useEffect, useState } from 'react';
import axios from '../../utils/axiosInterceptor';
import { useSelector } from "react-redux";
import { useNavigate, Link } from 'react-router-dom'

import { Box, Divider, Typography, Grid, Button, Container, FormControl, TextField, Paper, CircularProgress,
TableBody, TableCell, TableHead, TableRow, Table, TableContainer, Dialog, DialogTitle, DialogContent, DialogActions  } from '@mui/material';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';
import { formatMoney } from '../../utils/functions/Utils';

import { useTheme } from '@mui/material/styles'

const StockIndex = () => { 

    const auth = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const theme = useTheme()

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [showDetails, setShowDetails] = useState(false);
    const [product, setProduct] = useState({});

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    useEffect(() => {
        if (!['Admin', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Control de Stock';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    const getData = async () => {
        setLoading(true);
        try {
            let res = await axios.get('/api/products/stock');
            setData(res.data);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    }

    useEffect(() => {
        getData();
    }, []);

    const handleShowDetails = async (id) => {
        try {
            const res = await axios.get(`/api/products/${id}`);
            if(res.status === 200) {
                setProduct(res.data);
                setShowDetails(true);
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al cargar el producto, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
        }
    }

    const handleClose = () => {
        setShowDetails(false);
        setProduct({});
    };

    const renderDetails = () => {
        if(product._id !== undefined) {
            return(
                <Dialog
                    fullWidth={true}
                    maxWidth={'md'}
                    className='exo2'
                    scroll='paper'
                    onClose={handleClose}
                    open={showDetails} >
                    <DialogTitle>Detalles del producto</DialogTitle>
                    <DialogContent>
                    <Box sx={{ width: '100%', padding: '24px', border: 'solid 1px comp.boxBorder', backgroundColor: 'comp.boxBg', borderRadius: '20px'}}>
                        <Box className='d-flex align-items-stretch justify-content-center mb-2'>
                            <Typography sx={{ fontSize: '1.1em', color: 'comp.spColor2' }} className='px-1 d-flex align-items-center'>Nombre del producto:</Typography>
                            <Typography sx={{ fontSize: '1.1em' }} className='px-1 text-bold'>{product.nombre ? product.nombre : ''}</Typography>
                        </Box>
                        <Grid container spacing={3}>
                            <Grid item xs={12} >
                                    <Box style={{display: 'flex', justifyContent: 'center'}}>
                                        <img alt='product-img' style={{width: 'auto', maxWidth: '400px', boxShadow: '2px 2px 10px #13161B', borderRadius: '20px'}} src={product.imagen} />
                                    </Box>
                                    <Box className='d-flex align-items-stretch justify-content-center'>
                                        <Typography sx={{ fontSize: '16px', color: 'comp.spColor1' }} className='my-3 px-1 d-flex align-items-center'>Unidades disponibles:</Typography>
                                        <Typography sx={{ fontSize: '16px' }} className='my-3 px-1 text-bold'>{product.cantidad ? product.cantidad + ' ' + product.unidad : ''}</Typography>
                                    </Box>
    
                                    <Divider className='my-3' textAlign="left">
                                        <CustomChip variant='outlined' estatus='DIAGNOSTICADO' label='Detalles del producto' className='text-bold' />
                                    </Divider>
    
                                    <Box >
                                        <Typography sx={{ fontSize: '16px', color: 'comp.spColor1' }} className='my-3 px-1 d-flex align-items-center'>Descripción:</Typography>
                                        <Typography sx={{ fontSize: '16px' }} className='my-3 px-1 text-bold'>{product.descripcion ? product.descripcion : ''}</Typography>
                                    </Box>
                                    <TableContainer>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Clave del Producto:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.clave ? product.clave : ''}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Categoría:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.categoria ? product.categoria : ''}</TableCell>
                                                </TableRow>
                                                    <TableRow>
                                                        <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Costo Unitario:</TableCell>
                                                        <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.costoUnitario ? `$ ${formatMoney(product.costoUnitario)}` : ''}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Precio Unitario:</TableCell>
                                                        <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.precioUnitario ? `$ ${formatMoney(product.precioUnitario)}` : ''}</TableCell>
                                                    </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Cantidad disponible:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.cantidad ? product.cantidad + ' ' + product.unidad : ''}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Stock Mínimo:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.stockMinimo ? product.stockMinimo : ''}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Stock Máximo:</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.stockMaximo ? product.stockMaximo : ''}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Nota de  Stock:</TableCell>
                                                    <TableCell sx={{fontSize: '16px', color: `${theme.palette.comp.spColor1}`}} className='text-bold'>{product.notaDeStock ? product.notaDeStock : ''}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider className='my-3' textAlign="left">
                                        <CustomChip variant='outlined' estatus='DIAGNOSTICADO' label='Caracteristicas del producto' className='text-bold' />
                                    </Divider>
                                <TableContainer>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Proveedor:</TableCell>
                                                <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.proveedor ? product.proveedor : ''}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Marca:</TableCell>
                                                <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.marca ? product.marca : ''}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Modelo:</TableCell>
                                                <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.modelo ? product.modelo : ''}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>No. Serie:</TableCell>
                                                <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.noSerie ? product.noSerie : ''}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>No. Inventario:</TableCell>
                                                <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.noInventario ? product.noInventario : ''}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Unidad:</TableCell>
                                                <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.unidad ? product.unidad : ''}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Caducidad:</TableCell>
                                                <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.caducidad ? product.caducidad : ''}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{fontSize: '16px', color: 'comp.spColor2'}}>Observaciones:</TableCell>
                                                <TableCell sx={{fontSize: '16px'}} className='text-bold'>{product.observaciones ? product.observaciones : ''}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider className='my-3' textAlign="left">
                                    <CustomChip variant='outlined' estatus='DIAGNOSTICADO' label='Ubicación en almacén' className='text-bold' />
                                </Divider>
                                <Box className='d-flex align-items-stretch'>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-center'>Almacén</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-center'>Anaquel</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-center'>Nivel</TableCell>
                                                    <TableCell sx={{fontSize: '16px'}} className='text-center'>Posición</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor1'}} className='text-bold text-center'>{product.ubicacion.almacen ? product.ubicacion.almacen : ''}</TableCell>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor1'}} className='text-bold text-center'>{product.ubicacion.anaquel ? product.ubicacion.anaquel : ''}</TableCell>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor1'}} className='text-bold text-center'>{product.ubicacion.nivel ? product.ubicacion.nivel : ''}</TableCell>
                                                    <TableCell sx={{fontSize: '16px', color: 'comp.spColor1'}} className='text-bold text-center'>{product.ubicacion.posicion ? product.ubicacion.posicion : ''}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </Grid>
                        </Grid>
                        <p></p>
                        <Box style={{ marginTop: '10px', marginBottom: '12px' }}>
                            {
                                ['Tecnico', 'Vendedor'].includes(auth.user.rol) ? <></> :
                                    <Link target='_blank' to={{ pathname: '/inventario/editarProducto/' + product._id, state: { id: product._id } }} style={{ textDecoration: 'none' }}>
                                        <Button sx={{ minWidth: '90px' }} variant='contained' color='primary' >
                                            Editar &nbsp;&nbsp;<i className='fad fa-edit'></i>
                                        </Button>
                                    </Link>   
                            }
                        </Box>
                    </Box>
                    </DialogContent>
                    <DialogActions>
                    <Button className='mx-2' color='warning' variant='contained' onClick={() => setShowDetails(false)}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                    </DialogActions>
                </Dialog>
            )
        } else {
            return <></>
        }
    }

    const renderProducts = () => {
        if (loading) {
            return(
                <Container style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <CircularProgress />
                </Container>
            )
        } else {
            return(
                <Container maxWidth='xxl'>
                    <Typography variant='h4' style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 700 }}>Control de Stock</Typography>
                    <Container maxWidth='xl' sx={{mb: 1}}>
                        <Button size='small' variant='outlined' onClick={() => navigate('/dashboard')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
                    </Container>
                    <Divider style={{ marginBottom: '10px' }} />
                    <FormControl fullWidth style={{ marginBottom: '10px' }}>
                        <TextField
                            id="search"
                            label="Buscar producto"
                            variant="outlined"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </FormControl>

                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell><Typography>Clave</Typography></TableCell>
                                    <TableCell><Typography>Producto</Typography></TableCell>
                                    <TableCell><Typography>Existencias</Typography></TableCell>
                                    <TableCell align="right"><Typography>Stock Mínimo</Typography></TableCell>
                                    <TableCell align="right"><Typography>Stock Máximo</Typography></TableCell>
                                    <TableCell align="right"><Typography>Nota de Stock</Typography></TableCell>
                                    <TableCell align="right"><Typography>Precio</Typography></TableCell>
                                    <TableCell align="right"><Typography>Acciones</Typography></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.filter((item) => {
                                    if (search === '') {
                                        return item;
                                    } else if (item.clave.toLowerCase().includes(search.toLowerCase())) {
                                        return item;
                                    }
                                }).map((item) => (
                                    <TableRow
                                        hover
                                        onDoubleClick={() => handleShowDetails(item._id)}
                                        key={item._id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <Typography variant='body1' sx={{fontWeight: 700}}>{item.clave}</Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <Typography variant='body1' >{item.descripcion}</Typography>
                                        </TableCell>
                                        <TableCell align="right" ><Typography color={`${item.flag ? '#FF0000' : 'text.primary'}`} sx={{fontWeight: 700}}>{item.cantidad}</Typography></TableCell>
                                        <TableCell align="right"><Typography>{item.stockMinimo}</Typography></TableCell>
                                        <TableCell align="right"><Typography>{item.stockMaximo}</Typography></TableCell>
                                        <TableCell align="right"><Typography>{item.notaDeStock}</Typography></TableCell>
                                        <TableCell align="right"><Typography>$ {formatMoney(item.precioUnitario)}</Typography></TableCell>
                                        <TableCell align="right">
                                        <Link target='_blank' to={{ pathname: '/inventario/editarProducto/' + item._id, state: { id: item._id } }} style={{ textDecoration: 'none' }}>
                                            <Button sx={{ minWidth: '90px' }} variant='contained' color='primary' size='small'>
                                                Editar &nbsp;&nbsp;<i className='fad fa-info-circle'></i>
                                            </Button>
                                        </Link>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Container>
            )
        }
    }

    return(
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>

            {renderProducts()}
            {renderDetails()}
            <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
        </Container>
    )
}

export default StockIndex;